import mobxStore from 'mobx/rootStore';
import React from 'react';

export const MobxContext = React.createContext({
  mobxStore: mobxStore,
});
